// Mirror action strings the backend writes for these audit log types; they have no GraphQL enum to import.
export const DESIGN_REQUEST_AUDIT_ACTIONS = [
  'DesignRequestCreated',
  'SubmittedToManagerReview',
  'RejectedByManager',
  'RejectedAndReassignedByManager',
  'SubmittedToStoreReviewByManager',
  'SubmittedToStoreReviewByDesigner',
  'RejectedByStore',
  'Escalated',
  'ReassignedByManager',
  'AcceptedByStore',
  'UploadedDesign',
  'MerchCreated',
  'PriorityChanged',
  'Archived',
];

export const PROMO_CODE_AUDIT_ACTIONS = [
  'PromoCodeCreated',
  'PromoCodeUpdated',
  'PromoCodeRedeemed',
];

export const COUNTER_OFFER_AUDIT_ACTIONS = [
  'CounterOfferProposed',
  'CounterOfferAccepted',
  'CounterOfferRejected',
];

export const DELIVERABLE_REVIEW_AUDIT_ACTIONS = ['DeliverableReviewed'];

export const CB_TEAM_AUDIT_ACTIONS = [
  'TeamMemberActivated',
  'TeamMemberRemoved',
  'TeamMemberRoleChanged',
  'TeamRoleUpdated',
  'TeamCapabilityChanged',
];
